import { DirectionProvider } from '@radix-ui/react-direction';
import type { ReactNode } from 'react';
import { useChromeDirection } from './useLocale';

/**
 * Hands the chrome direction to every Radix primitive below it.
 *
 * Radix reads `dir` from its prop, else from this context, else defaults to "ltr" — and
 * the primitives that use it write that value to the DOM, which overrides `<html dir>`.
 * Without this, any primitive that forgets an explicit `dir` renders an LTR island inside
 * the Arabic console. The portalled wrappers in lib/ui also pass `dir` explicitly.
 */
export function ChromeDirectionProvider({ children }: { children: ReactNode }) {
  const dir = useChromeDirection();
  return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}
